import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import CreateCourse from 'experienceComponents/CreateCourse'
import CreateSmallGroup from 'experienceComponents/CreateSmallGroup'

export const CreateClassModals = ({
  contentfulCourses,
  createCourseAutoOpen,
  createCourseInstanceV2ProgramFlex,
  createCourseInstanceByCourse,
  createSmallGroupAutoOpen,
  showSmallGroupCreation = true,
  deleteCourseInstance,
  deletingCourseCreatedStatus,
  fetchInstructorData,
  lms,
  pathName,
  updateCourseInstance,
  userAccess,
  userContext,
  userProfile,
}) => {
  const sharedModalProps = useMemo(
    () => ({
      contentfulCourses,
      createCourseInstanceByCourse,
      createCourseInstanceV2ProgramFlex,
      deleteCourseInstance,
      deletingCourseCreatedStatus,
      emptyClasses: true,
      fetchInstructorData,
      hideLauncher: true,
      lms,
      pathName,
      updateCourseInstance,
      userAccess,
      userContext,
      userProfile,
    }),
    [
      contentfulCourses,
      createCourseInstanceByCourse,
      createCourseInstanceV2ProgramFlex,
      deleteCourseInstance,
      deletingCourseCreatedStatus,
      fetchInstructorData,
      lms,
      pathName,
      updateCourseInstance,
      userAccess,
      userContext,
      userProfile,
    ],
  )

  return (
    <>
      <CreateCourse autoOpen={createCourseAutoOpen} {...sharedModalProps} />
      {showSmallGroupCreation && (
        <CreateSmallGroup
          autoOpen={createSmallGroupAutoOpen}
          {...sharedModalProps}
        />
      )}
    </>
  )
}

CreateClassModals.propTypes = {
  contentfulCourses: PropTypes.arrayOf(
    PropTypes.shape({
      displayTitle: PropTypes.string,
    }),
  ).isRequired,
  createCourseAutoOpen: PropTypes.bool.isRequired,
  createCourseInstanceByCourse: PropTypes.func,
  createCourseInstanceV2ProgramFlex: PropTypes.func,
  createSmallGroupAutoOpen: PropTypes.bool.isRequired,
  deleteCourseInstance: PropTypes.func,
  deletingCourseCreatedStatus: PropTypes.func,
  fetchInstructorData: PropTypes.func,
  lms: PropTypes.object,
  pathName: PropTypes.string,
  showSmallGroupCreation: PropTypes.bool,
  updateCourseInstance: PropTypes.func,
  userAccess: PropTypes.object,
  userContext: PropTypes.object,
  userProfile: PropTypes.object,
}
